import { useState, useEffect, useRef } from "react";
import { fetchDataPost, fetchDataGet } from "../../controler/comunicacao";
import Loading from "../../components/LoadingAnimation/LoadingAnimation";
import { useQuery } from "@tanstack/react-query";
import Modal from "../../components/Modal/Modal";
import DropdownToolTip from "../../components/Dropdown/DropdownToolTip"

const SECONDS = 1000;
const MINUTES = 60;
const HOURS = 60;
const DAYS = 24;

let filters = [
  {
    titulo: "Escolha a modalidade",
    opcoes: ["Notificações", "Óbito", "Abandono"]
  },
  {
    titulo: "Escolha os anos",
    opcoes: ["TODOS", 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012]
  },
  {
    titulo: "Escolha o nível de visualização",
    opcoes: ["Nacional", "Estadual"]
  },
  {
    titulo: "Escolha o estado",
    opcoes: ["SP", "RJ", "MG", "ES", "PR", "SC", "RS", "MS", "MT", "GO", "DF", "BA", "SE", "AL", "PE", "PB", "RN", "CE", "PI", "MA", "PA", "AP", "RR", "AM", "AC", "RO", "TO"]
  },
  {
    titulo: "Escolha o tipo de mapa",
    opcoes: [
      "Linear",
      "Moran",
      "Mapa de calor",
      "Cluster"
    ]
  },
  {
    titulo: "Escolha a variavel principal",
    opcoes: [
      "Número de casos",
      "Incidência"
    ],
  }
];

const allYearsFromFilters = filters.find(f => f.titulo === "Escolha os anos")
  .opcoes.filter(opt => opt !== "TODOS")
  .map(year => ({ value: year, label: year }));

const useData = (MODALIDADE, NIVEL_VISUALIZACAO, ESTADO, TIPO_MAPA, LISTA_ANOS, VARIAVEL_PRINCIPAL) => {
  const hash = `${MODALIDADE.map(x => x.value).join(',')}-${NIVEL_VISUALIZACAO.map(x => x.value).join(',')}-${ESTADO.map(x => x.value).join(',')}-${TIPO_MAPA.map(x => x.value).join(',')}-${LISTA_ANOS.map(x => x.value).join(',')}-${VARIAVEL_PRINCIPAL.map(x => x.value).join(',')}-version-006`;
  return useQuery({
    queryKey: [hash],
    queryFn: async () => {
      const selectedModalidade = MODALIDADE[0].value;
      const selectedNivelVisualizacao = NIVEL_VISUALIZACAO[0].value;
      const selectedTipoMapa = TIPO_MAPA[0].value;
      const selectedVariavelPrincipal = VARIAVEL_PRINCIPAL[0].value;

      const selectedEstado = selectedNivelVisualizacao === "pais" ? "TODOS" : ESTADO[0].value;

      const result = await fetchDataPost("/api/generate_map",
        {
          "modalidade": selectedModalidade,
          "nivel_visualizacao": selectedNivelVisualizacao,
          "estado_selecionado": selectedEstado,
          "tipo_mapa": selectedTipoMapa,
          "lista_anos": LISTA_ANOS.map(x => x.value),
          "variavel_principal": selectedVariavelPrincipal
        });
      return result;
    },
    staleTime: SECONDS * MINUTES * HOURS * DAYS * 15, // cache por 15 dias
    cacheTime: SECONDS * MINUTES * HOURS * DAYS * 15, // cache por 15 dias
    refetchOnWindowFocus: false,
  });
};

function Mapas() {
  const [MODALIDADE, setMODALIDADE] = useState([{ value: "INCIDENCIA", label: "Notificações" }]);
  const [NIVEL_VISUALIZACAO, setNIVEL_VISUALIZACAO] = useState([{ value: "pais", label: "Nacional" }]);
  const [ESTADO, setESTADO] = useState([{ value: "SP", label: "SP" }]);
  const [TIPO_MAPA, setTIPO_MAPA] = useState([{ value: "LINEAR_AZUL", label: "LINEAR_AZUL" }]);
  const [LISTA_ANOS, setLISTA_ANOS] = useState(allYearsFromFilters);
  const [VARIAVEL_PRINCIPAL, setVARIAVEL_PRINCIPAL] = useState([{ value: "NumeroCasos", label: "Número de casos" }]);

  const [areFiltersOpen, setAreFiltersOpen] = useState(false);
  const [mapBlobUrl, setMapBlobUrl] = useState(null);
  const prevBlobUrl = useRef(null);

  const { data: anosData } = useQuery({
    queryKey: ['anos-v2'],
    queryFn: () => fetchDataGet('/api/anos'),
    staleTime: SECONDS * MINUTES * HOURS * DAYS * 15,
    refetchOnWindowFocus: false,
    retry: 0,
  });

  useEffect(() => {
    if (anosData) {
      const anosFiltro = filters.find(f => f.titulo === "Escolha os anos");
      anosFiltro.opcoes = ["TODOS", ...anosData];
      setLISTA_ANOS(anosData.map(a => ({ value: parseInt(a, 10), label: String(a) })));
    }
  }, [anosData]);

  const handleFilterUpdate = (
    MODALIDADE,
    NIVEL_VISUALIZACAO,
    ESTADO,
    TIPO_MAPA,
    LISTA_ANOS,
    VARIAVEL_PRINCIPAL,
  ) => {
    setMODALIDADE(MODALIDADE)
    setNIVEL_VISUALIZACAO(NIVEL_VISUALIZACAO);
    setESTADO(ESTADO);
    setTIPO_MAPA(TIPO_MAPA);
    setLISTA_ANOS(LISTA_ANOS);
    setVARIAVEL_PRINCIPAL(VARIAVEL_PRINCIPAL);
  };

  const applyFilters = () => {
    const selectedFilters = {
      MODALIDADE: selecionados["Escolha a modalidade"].map(value => {
        let transformedValue = value;
        if (value === "Notificações") {
          transformedValue = "INCIDENCIA";
        } else if (value === "Óbito") {
          transformedValue = "OBITO";
        } else if (value === "Abandono") {
          transformedValue = "ABANDONO";
        }
        return { value: transformedValue, label: value };
      }),
      LISTA_ANOS: selecionados["Escolha os anos"].includes("TODOS")
        ? filters.find(f => f.titulo === "Escolha os anos").opcoes
            .filter(opt => opt !== "TODOS")
            .map(a => ({ value: parseInt(a, 10), label: String(a) }))
        : selecionados["Escolha os anos"].map(value => ({ value: parseInt(value, 10) || value, label: String(value) })),
      NIVEL_VISUALIZACAO: selecionados["Escolha o nível de visualização"].map(value => {
        let transformedValue = value;
        if (value === "Estadual") {
          transformedValue = "estado";
        } else if (value === "Nacional") {
          transformedValue = "pais";
        }
        return { value: transformedValue, label: value };
      }),
      ESTADO: selecionados["Escolha o estado"].map(value => ({ value, label: value })),
      VARIAVEL_PRINCIPAL: selecionados["Escolha a variavel principal"].map(value => {
        let transformedValue = value;
        if (value === "Número de casos") {
          transformedValue = "NumeroCasos";
        } else if (value === "Incidência") {
          transformedValue = "incidencia";
        }
        return { value: transformedValue, label: value };
      }),
      TIPO_MAPA: selecionados["Escolha o tipo de mapa"].map(value => {
        let transformedValue = value;
        if (value === "Linear") {
          transformedValue = "LINEAR_AZUL";
        } else if (value === "Moran") {
          transformedValue = "MORAN";
        } else if (value === "Mapa de calor") {
          transformedValue = "HEATMAP";
        } else if (value === "Cluster") {
          transformedValue = "CLUSTER_MARCADORES";
        }
        return { value: transformedValue, label: value };
      }),
    };

    Object.keys(selectedFilters).forEach(key => {
      if (selectedFilters[key].length === 0) {
        selectedFilters[key] = [{ value: "TODOS", label: "TODOS" }];
      }
    });
    handleFilterUpdate(
      selectedFilters.MODALIDADE,
      selectedFilters.NIVEL_VISUALIZACAO,
      selectedFilters.ESTADO,
      selectedFilters.TIPO_MAPA,
      selectedFilters.LISTA_ANOS,
      selectedFilters.VARIAVEL_PRINCIPAL,
    );
  }

  const estadoInicial = filters.reduce((acc, filtro) => {
    acc[filtro.titulo] = [filtro.opcoes[0]];
    return acc;
  }, {});

  const [selecionados, setSelecionados] = useState(estadoInicial);

  let { data, isLoading } = useData(MODALIDADE, NIVEL_VISUALIZACAO, ESTADO, TIPO_MAPA, LISTA_ANOS, VARIAVEL_PRINCIPAL);

  useEffect(() => {
    if (!data) return;
    const blob = new Blob([data], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    setMapBlobUrl(url);
    const prev = prevBlobUrl.current;
    prevBlobUrl.current = url;
    return () => { if (prev) URL.revokeObjectURL(prev); };
  }, [data]);

  const handleCheckbox = (filtro, opcao) => {
    setSelecionados(prev => {
      let novosSelecionados;

      if (["Escolha a modalidade", "Escolha o nível de visualização", "Escolha o tipo de mapa", "Escolha a variavel principal", "Escolha o estado"].includes(filtro)) {
        novosSelecionados = [opcao];
      } else {
        const todasOpcoes = ["TODOS"];
        const ehOpcaoTodas = todasOpcoes.includes(opcao);
        const jaSelecionado = prev[filtro]?.includes(opcao);

        if (ehOpcaoTodas) {
          novosSelecionados = jaSelecionado ? [] : [opcao];
        } else {
          novosSelecionados = jaSelecionado
            ? prev[filtro].filter(o => o !== opcao)
            : [...prev[filtro].filter(o => !todasOpcoes.includes(o)), opcao];
        }
      }
      return {
        ...prev,
        [filtro]: novosSelecionados
      };
    });
  };

  const isChecked = (filtro, opcao) => {
    return selecionados[filtro]?.includes(opcao);
  };

  return (

    <section className="container-fluid dashboard px-0 dashboard-section" >

      {/* Filters */}
      < div className="titulo p-3 d-flex justify-content-between align-items-center" >
        <div className="titulo-nome">
          {MODALIDADE[0].value === "OBITO"
            ? "Óbitos por tuberculose"
            : MODALIDADE[0].value === "ABANDONO"
              ? "Interrupções de tratamento"
              : "Notificações de tuberculose"}
        </div>

        <button className="filter-button" onClick={() => areFiltersOpen ? setAreFiltersOpen(false) : setAreFiltersOpen(true)}>Filtros</button>
      </div >
      <div className={`${areFiltersOpen ? "on show container-fluid mt-4 filters-section" : "on hide container-fluid mt-4 filters-section"}`}>
        <div className="d-flex overflow-auto gap-3 pb-2">
          {filters
            .filter(filtro => {
              if (filtro.titulo === "Escolha o estado") {
                return selecionados["Escolha o nível de visualização"]?.includes("Estadual");
              }
              return true;
            })
            .map((filtro, index) => (
              <div key={index} className="card" style={{ minWidth: "250px", maxHeight: "300px", overflowY: "auto" }}>
                <div className="card-body" style={{ boxShadow: "none" }}>
                  <h5 className="card-title">{filtro.titulo}</h5>
                  <div>
                    {filtro.opcoes.map((opcao, i) => {
                      const marcado = isChecked(filtro.titulo, opcao);
                      return (
                        <div key={i} className="form-check mb-1">
                          <input
                            className="form-check-input"
                            type={["Escolha a modalidade", "Escolha o nível de visualização", "Escolha o tipo de mapa", "Escolha a variavel principal", "Escolha o estado"].includes(filtro.titulo) ? "radio" : "checkbox"}
                            name={["Escolha a modalidade", "Escolha o nível de visualização", "Escolha o tipo de mapa", "Escolha a variavel principal", "Escolha o estado"].includes(filtro.titulo) ? filtro.titulo : undefined}
                            id={`${filtro.titulo}-${opcao}`}
                            checked={marcado}
                            onChange={() => handleCheckbox(filtro.titulo, opcao)}
                          />
                          <label className="form-check-label" htmlFor={`${filtro.titulo}-${opcao}`}>
                            {opcao}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="text-end mt-3">
          <button className="btn btn-primary" onClick={applyFilters}>Aplicar</button>
        </div>
      </div >

      {/* Map */}
      <div className="card map-container-container">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="m-0">Mapa de {MODALIDADE[0].label}</h5>

          <div className="d-inline-flex align-items-center">
            <DropdownToolTip>
              <p className="mb-2">
                Utilize o mapa para visualizar a distribuição de Interrupções de Tratamento em diferentes regiões.
              </p>
              <p className="mb-2">
                Passe o cursor sobre uma região para ver detalhes específicos sobre a distribuição de Interrupções de Tratamento nessa área.
              </p>
              <p className="mb-2">
                <strong>Mapa de Calor:</strong> Visualiza a densidade de casos em diferentes regiões.
              </p>
              <p className="mb-2">
                <strong>Mapa de Cluster:</strong> Identifica agrupamentos de alta e baixa incidência de casos.
              </p>
              <p className="mb-2">
                <strong>Mapa de Moran:</strong> Mostra a autocorrelação espacial dos casos, indicando padrões espaciais.
              </p>
              <p className="mb-2">
                <strong>Mapa de Incidência:</strong> Exibe a taxa de incidência de casos por região.
              </p>
            </DropdownToolTip>

            <Modal title={`Mapa de ${MODALIDADE[0].label}`} id="ModalMap">
              <iframe
                src={mapBlobUrl}
                title="Mapa Tuberculose"
                width="100%"
                height="100%"
                className="map-container map-fullscreen"
              />
            </Modal>
          </div>
        </div>
      </div>

      <div className="map-container map-normal">
        {isLoading ? <Loading /> :
          <iframe
            src={mapBlobUrl}
            title="Mapa Tuberculose"
            width="100%"
            height="100%"
            className="map-container"
          />}
      </div>
    </section >
  );
}

export default Mapas;
